// Split out of EdgeGraph.js: SigmaEdgeGraphLoader.js needs DEFAULT_NODE_SIZE, and
// EdgeGraph.js imports SigmaEdgeGraphLoader, which made them a circular import.
export const DEFAULT_NODE_SIZE = 4;
